import { Flex, Image } from '@chakra-ui/react';
import { useBreakpointValue } from '@ifixit/ui/hooks/use-media-query';
import { Flag } from './GuideHeader';
import { DefaultFlagStyle, getIcon } from './FlagSection';
import { FaIcon } from '@ifixit/icons';

export function FullWidthFlags(props: { flags: Array<Flag> }) {
   const fullWidthFlags = props.flags.filter(flag => flag.fullWidth);
   const showRightIcon = useBreakpointValue({ base: false, md: true });

   if (!fullWidthFlags.length) {
      return null;
   }
   const themeColor = DefaultFlagStyle.themeColor;

   const FlagIcon = ({ flag }: { flag: Flag }) => {
      const iconSize = '37px';
      return 'image' in flag ? (
         <Image
            src={flag.image}
            height={iconSize}
            width={iconSize}
            display="flex"
            alignSelf="center"
         />
      ) : (
         <FaIcon fontSize={iconSize} icon={getIcon(flag.icon)} color={`${themeColor}.500`} />
      );
   };

   return (
      <Flex flexDir="column" rowGap="16px" marginX={{ base: '16px', sm: '0px' }} marginY="16px">
         {fullWidthFlags.map((flag, index) => (
            <Flex
               key={index}
               flex={1}
               justifyContent="center"
               alignItems="center"
               background={`${themeColor}.100`}
               color={`${themeColor}.700`}
               border="2px solid"
               borderColor={`${themeColor}.300`}
               borderRadius="6px"
               paddingX="30px"
               paddingY="14px"
            >
               <FlagIcon flag={flag} />
               <Flex
                  flex="10 1"
                  flexDir="column"
                  marginInline="20px"
                  alignItems={{ base: 'flex-start', md: 'center' }}
                  textAlign={{ base: 'left', md: 'center' }}
               >
                  <Flex fontSize="16px" fontWeight="bold">
                     {flag.title}
                  </Flex>
                  <Flex fontSize="14px">{flag.text}</Flex>
               </Flex>
               {showRightIcon && <FlagIcon flag={flag} />}
            </Flex>
         ))}
      </Flex>
   );
}
